import { z } from 'zod';

const timeUtcSchema = z
  .string()
  .min(1, 'Time is required')
  .regex(
    /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/,
    'Time must be in the format "HH:MM"',
  );

export const createTestInputsSchema = z.object({
  chargePower: z.number().optional(),
  chargeEnergy: z.number().optional(),

  chargeStartDate: z.date({ required_error: 'Start date is required' }),
  chargeStartTimeUtc: timeUtcSchema,
  chargeEndDate: z.date({ required_error: 'End date is required' }),
  chargeEndTimeUtc: timeUtcSchema,

  dischargePower: z.number().optional(),
  dischargeEnergy: z.number().optional(),

  dischargeStartDate: z.date({ required_error: 'Start date is required' }),
  dischargeStartTimeUtc: timeUtcSchema,
  dischargeEndDate: z.date({ required_error: 'End date is required' }),
  dischargeEndTimeUtc: timeUtcSchema,
});

export type CreateTestInputs = z.infer<typeof createTestInputsSchema>;
